import { PencilFill, Trash3 } from "react-bootstrap-icons";

//App
import Button from "../VFX-UI/Button/Button";
import { useBottomFormStyles } from "./styles";
import LoadingIndicator from "../VFX-UI/LoadingIndicator/LoadingIndicator";
import { Label } from "reactstrap";
import { ActionBarProps } from "../../../types";
import { IsMobile } from "../../../utility/lib/breakpoints";

const ActionBar: React.FC<ActionBarProps> = ({
    submitText,
    displayText,
    displayTextStyle,
    cancelText,
    submitDisabled,
    isLoading,
    customImageButton,
    submitButtonLoading,
    cancelHandler,
    editHandler,
    submitHandler,
    deleteHandler,
}) => {
    const bottomFormStyles = useBottomFormStyles();
    const shouldCenterCustomImageButton =
        Boolean(customImageButton) &&
        IsMobile();
    return (
        <>
            <div className="container-fluid" style={{ height: "100%" }}>
                <div style={bottomFormStyles.flexGrow}></div>
                <div
                    style={{
                        ...bottomFormStyles.buttonGroup,
                        ...(shouldCenterCustomImageButton && { justifyContent: "center" }),
                    }}
                >
                    {isLoading ? (
                        <LoadingIndicator notFullPage />
                    ) : (
                        <>
                            {!shouldCenterCustomImageButton && <div style={bottomFormStyles.padding}>
                                {displayText && <Label style={displayTextStyle}>{displayText}</Label>}
                                {editHandler && (
                                    <Button
                                        style={bottomFormStyles.editButton}
                                        onClick={(e) => { editHandler(e); }} >
                                        <PencilFill /> Edit
                                    </Button>
                                )}
                                {deleteHandler && (
                                    <Button
                                        style={bottomFormStyles.deleteButton}
                                        onClick={(e) => {
                                            deleteHandler(e);
                                        }}
                                    >
                                        <Trash3 /> Delete
                                    </Button>
                                )}
                            </div>}
                            <div style={bottomFormStyles.padding}>
                                {submitHandler && <>
                                    {customImageButton ? <Button style={bottomFormStyles.customButtonContainerStyle} onClick={submitHandler} disabled={submitDisabled} >
                                        {submitButtonLoading ? (
                                            <div style={bottomFormStyles.submitWithLoadingIndicator}>
                                                <LoadingIndicator notFullPage size="sm" style={bottomFormStyles.loadingIndicator}  />
                                            </div>
                                        ) : (
                                            <img src={customImageButton} className="img-fluid" style={bottomFormStyles.customButtonImageStyle}></img>
                                        )}
                                    </Button> : <Button style={ submitButtonLoading ? bottomFormStyles.submitButtonDisabled : bottomFormStyles.submitButton } onClick={submitHandler} disabled={submitDisabled} >
                                        {submitButtonLoading ? (
                                            <div style={bottomFormStyles.submitWithLoadingIndicator}>
                                                <LoadingIndicator notFullPage size="sm" style={bottomFormStyles.loadingIndicator} />
                                                <span style={bottomFormStyles.submitTextInsideIndicator}>
                                                    {submitText}
                                                </span>
                                            </div>
                                        ) : (
                                            submitText
                                        )}
                                    </Button>}

                                </>}
                                {cancelHandler && (
                                    <Button
                                        style={bottomFormStyles.cancelButton}
                                        onClick={cancelHandler}
                                    >
                                        {cancelText}
                                    </Button>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default ActionBar;
